import { ReactNode } from 'react';
import styled from 'styled-components';

import { LegacyTertiaryButton } from 'components/LegacyButton/LegacyTertiaryButton';
import { ToggleHelperContainer } from 'containers/ToggleHelperContainer';
import { colors, fontWeights } from 'theme/theme';
import { isDefined } from 'utils/functional';

const ToggleLink = styled.div`
  padding-bottom: 31px;

  &::before {
    content: '+ ';
    color: ${colors.brandBlue};
    font-weight: ${fontWeights.semiBold};
  }
`;

export const ToggleSection = styled(
  ({
    children,
    title,
    className,
    toggleQaId,
  }: {
    children: ReactNode;
    title?: string;
    className?: string;
    toggleQaId?: string;
  }) =>
    isDefined(title) ? (
      <ToggleHelperContainer>
        {(toggled, toggle) => (
          <div
            style={{ position: 'relative', paddingTop: 31 }}
            className={className}
          >
            <div>
              {toggled ? (
                children
              ) : (
                <ToggleLink>
                  <LegacyTertiaryButton
                    onClick={toggle}
                    data-qa-id={toggleQaId}
                  >
                    {title}
                  </LegacyTertiaryButton>
                </ToggleLink>
              )}
            </div>
          </div>
        )}
      </ToggleHelperContainer>
    ) : (
      children
    ),
)`
  &:last-child {
    &::after {
      opacity: 0;
    }
  }
`;
